export enum ShoppingCartUploadResultType {
    Found = 'Found',
    Replacement = 'Replacement',
    Used = 'Used',
    NotFound = 'NotFound',
}
